import { i18n } from "@tellescope/i18n";
import { differenceInMinutes } from "date-fns/differenceInMinutes";

export const formatRangeDuration = (start: Date, end: Date) => {
  const totalMinutes = differenceInMinutes(end, start);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) {
    return i18n.t("{{count}} mins", { count: minutes, ns: "calendar" });
  }
  if (minutes === 0) {
    return i18n.t("{{count}} hrs", { count: hours, ns: "calendar" });
  }
  return i18n.t("{{hours}}h {{minutes}}m", { hours, minutes, ns: "calendar" });
};
